import React from "react";
import InputFactory from "../../../../../components/InputFactory";

export default function ChangePasswordModal({ onChange }) {
  return (
    <div>
      <p className="fw-bold m-0" style={{ fontSize: "1.2rem" }}>
        Change Password
      </p>
      <div>
        <div>
          <p
            className="fw-medium"
            style={{ fontSize: ".875rem", paddingTop: "1.5rem" }}
          >
            Old Password
          </p>
          <InputFactory
            type="Password"
            field="oldPassword"
            placeholder="Minimum of 8 characters"
            onChange={onChange}
          />
        </div>
        <div>
          <p
            className="fw-medium"
            style={{ fontSize: ".875rem", paddingTop: "1.5rem" }}
          >
            New Password
          </p>
          <InputFactory
            type="Password"
            field="newPassword"
            onChange={onChange}
            placeholder="Minimum of 8 characters"
          />
        </div>
        <div>
          <p
            className="fw-medium"
            style={{ fontSize: ".875rem", paddingTop: "1.5rem" }}
          >
            Confirm Password
          </p>
          <InputFactory
            type="Password"
            field="confirmNewPassword"
            onChange={onChange}
            placeholder="Minimum of 8 characters"
          />
        </div>
      </div>
    </div>
  );
}
